/* tslint:disable */
/* eslint-disable */
/* @relayHash 74e859ad6f3d71832e3c5e58d7c0eb00 */

import { ConcreteRequest } from "relay-runtime";
export type STORY_STATUS = "CLOSED" | "OPEN" | "%future added value";
export type OpenStoryInput = {
    id: string;
    clientMutationId: string;
};
export type OpenStoryMutationVariables = {
    input: OpenStoryInput;
};
export type OpenStoryMutationResponse = {
    readonly openStory: {
        readonly story: {
            readonly id: string;
            readonly status: STORY_STATUS;
            readonly closedAt: string | null;
            readonly isClosed: boolean;
            readonly isArchiving: boolean;
            readonly isArchived: boolean;
        } | null;
        readonly clientMutationId: string;
    };
};
export type OpenStoryMutation = {
    readonly response: OpenStoryMutationResponse;
    readonly variables: OpenStoryMutationVariables;
};



/*
mutation OpenStoryMutation(
  $input: OpenStoryInput!
) {
  openStory(input: $input) {
    story {
      id
      status
      closedAt
      isClosed
      isArchiving
      isArchived
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "OpenStoryPayload",
            "kind": "LinkedField",
            "name": "openStory",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "story",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "closedAt",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isClosed",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isArchiving",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isArchived",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "OpenStoryMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "OpenStoryMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "74e859ad6f3d71832e3c5e58d7c0eb00",
            "metadata": {},
            "name": "OpenStoryMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'cf8a75fb06acf3d56828daffe9407367';
export default node;
